"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorOptimizeQueryOperationLeftjoinExpressionPushdown = void 0;
const bus_optimize_query_operation_1 = require("@comunica/bus-optimize-query-operation");
const context_entries_1 = require("@comunica/context-entries");
const core_1 = require("@comunica/core");
const utils_algebra_1 = require("@comunica/utils-algebra");
const utils_query_operation_1 = require("@comunica/utils-query-operation");
/**
 * A comunica LeftJoin Expression Pushdown Optimize Query Operation Actor.
 */
class ActorOptimizeQueryOperationLeftjoinExpressionPushdown extends bus_optimize_query_operation_1.ActorOptimizeQueryOperation {
    constructor(args) {
        super(args);
    }
    async test(_action) {
        return (0, core_1.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe(context_entries_1.KeysInitQuery.dataFactory);
        const algebraFactory = new utils_algebra_1.AlgebraFactory(dataFactory);
        let operation = action.operation;
        // eslint-disable-next-line ts/no-this-alias
        const self = this;
        // TODO: pass algebraFactory when traqula supports this.
        operation = utils_algebra_1.algebraUtils.mapOperation(operation, {
            [utils_algebra_1.Algebra.Types.LEFT_JOIN]: {
                transform: (op) => {
                    // Try to push the expression to the right if it exclusively overlaps with that one.
                    if (op.expression) {
                        const variablesExpression = (0, utils_query_operation_1.getExpressionVariables)(op.expression);
                        const variablesLeft = utils_algebra_1.algebraUtils.inScopeVariables(op.input[0]);
                        const variablesRight = utils_algebra_1.algebraUtils.inScopeVariables(op.input[1]);
                        const intersectLeft = self.variablesIntersect(variablesExpression, variablesLeft);
                        const intersectRight = self.variablesIntersect(variablesExpression, variablesRight);
                        if (!intersectLeft && intersectRight) {
                            self.logDebug(action.context, `Pushed down optional expression to right-hand operator`);
                            return algebraFactory.createLeftJoin(op.input[0], algebraFactory.createFilter(op.input[1], op.expression));
                        }
                    }
                    return op;
                },
            },
        });
        return { operation, context: action.context };
    }
    /**
     * Check if there is an overlap between the two given lists of variables.
     * @param varsA A list of variables.
     * @param varsB A list of variables.
     */
    variablesIntersect(varsA, varsB) {
        return varsA.some(varA => varsB.some(varB => varA.equals(varB)));
    }
}
exports.ActorOptimizeQueryOperationLeftjoinExpressionPushdown = ActorOptimizeQueryOperationLeftjoinExpressionPushdown;
//# sourceMappingURL=ActorOptimizeQueryOperationLeftjoinExpressionPushdown.js.map